module.exports = __webpack_public_path__ + "static/media/scroll-indicator.181f91c8.png";